export const STATUS_TEXT = {
  UNKNOWN: 'Unknown',
  ERROR_FALLBACK: 'Something went wrong',
  SERVER_ERROR: 'Internal server error',
  GATEWAY_TIMEOUT: 'Gateway timeout',
  UNAUTHORIZED: 'Unauthorized',
  NOT_FOUND: 'Not found',
  FORBIDDEN: 'Forbidden',
  BAD_REQUEST: 'Bad request',
  REQUEST_TIMEOUT: 'Request timeout',
};

export enum StatusCode {
  SERVER_ERROR = 500,
  GATEWAY_TIMEOUT = 504,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  REQUEST_TIMEOUT = 408,
}

export const EMAIL_SUCCESS = {
  SEND: 'Sent e-mail',
  OK: 'OK',
};
